import { memo } from 'react'
import { Center, Text, Skeleton, Stack } from 'components'
import { useTranslation } from 'react-i18next'

interface BrowseTreeEmptyStateProps {
  isLoading?: boolean
  message?: string
}

export const BrowseTreeEmptyState = memo(({
  isLoading = false,
  message,
}: BrowseTreeEmptyStateProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <Stack spacing="xs" p="md">
        {[1, 2, 3, 4, 5].map(i => (
          <Skeleton key={i} height={48} radius="md" />
        ))}
      </Stack>
    )
  }

  return (
    <Center py="xl">
      <Text size="sm" color="dimmed">
        {message ?? t('arc_browse_no_items')}
      </Text>
    </Center>
  )
})

BrowseTreeEmptyState.displayName = 'BrowseTreeEmptyState'
